import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import PropTypes from 'prop-types'
import AllTimeScheduleList from './AllTimeScheduleList'
import Single from '../components/Single'
// import GLOBAL from '../Global'
import '../css/ScheduleTour.css'

const END_POINT = 'https://mk-official-data.firebaseio.com/tour.json'
// const END_POINT = '/data/tour.json'

class AllTimeSchedule extends Component {
  constructor(props) {
    super(props)
    this.path = props.history.location.pathname // 現在のパス
    this.state = {
      tour: [],
    }
  }

  componentDidMount() {
    axios.get(END_POINT).then(result => {
      this.setState({ tour: result.data })
    })
  }

  render() {
    const {
      state: { tour },
      props: { history },
    } = this
    const path = history.location.pathname // 現在のパス
    if (path === '/alltimeschedule/' || path === '/alltimeschedule') {
      return (
        <>
          <h1>ALL TIME SCHEDULE</h1>
          <AllTimeScheduleList data={tour} />
        </>
      )
    }
    return <Single category="alltimeschedule" data={tour} path={path} />
  }
}

export default withRouter(AllTimeSchedule)

AllTimeSchedule.propTypes = {
  history: PropTypes.object,
}

AllTimeSchedule.defaultProps = {
  history: null,
}
